module.exports = __webpack_public_path__ + "static/media/lendo-jornal.c85b57a9.jpg";